import theme from "../../../../js/shared/new-theme";

import {
  fontSize32,
  gridGutter1q3
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const boxTotalExpectedGainStyle = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin: 0;
  }
  .text {
    font-weight: bold;
    opacity: 0.87;
  }
  .price-area {
    display: flex;
    align-items: center;
    justify-content: center;
    &--text {
      color: ${theme.palette.gray[800].value};
      font-size: ${fontSize32};
      font-weight: bold;
      margin-right: ${gridGutter1q3}px;
    }
  }
`;
